/**
 * Types of different frauds.
 */
module.exports = {
  MULTIPLE_ADDR_ORIGIN: 'EV-HST-FRAUD-MULTIPLE-ORIGIN',
  LONG_UNFOCUS_TIME: 'EV-HST-FRAUD-LONG-UNFOCUS-TIME',
};
